function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("ellipse", {
  id: "hero-image_svg__ellipse982",
  fill: "#e6e6e6",
  ry: 45.051,
  rx: 167.083,
  cy: 747.949,
  cx: -167.083,
  transform: "scale(-1 1)",
  strokeWidth: 1.342
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "hero-image_svg__path984",
  fill: "#3e3d54",
  d: "M887 0H1a-734 734 0 00734 734h152z",
  fillOpacity: 1
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  id: "hero-image_svg__circle986",
  fill: "#f2f2f2",
  r: 71.883,
  cy: 178.425,
  cx: -234.141,
  transform: "scale(-1 1)"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  id: "hero-image_svg__circle988",
  fill: "#ff6584",
  cy: 101.28,
  cx: -725.624,
  transform: "scale(-1 1)",
  r: 6.161
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  id: "hero-image_svg__circle990",
  fill: "#ff6584",
  r: 6.161,
  cy: 445.419,
  cx: -254.679,
  transform: "scale(-1 1)"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  id: "hero-image_svg__circle992",
  fill: "#f2f2f2",
  cy: 120.284,
  cx: -534.111,
  transform: "scale(-1 1)",
  r: 6.161
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  id: "hero-image_svg__circle996",
  fill: "#f2f2f2",
  r: 6.161,
  cy: 198.963,
  cx: -393.311,
  transform: "scale(-1 1)"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  id: "hero-image_svg__circle998",
  fill: "#f2f2f2",
  cy: 243.49,
  cx: -831.621,
  transform: "scale(-1 1)",
  r: 6.161
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  id: "hero-image_svg__circle1000",
  fill: "#6395ff",
  r: 209.488,
  cy: 413.585,
  cx: -602.799,
  transform: "scale(-1 1)"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  id: "hero-image_svg__circle1002",
  opacity: 0.2,
  r: 30.807,
  cy: 328.353,
  cx: -612.041,
  transform: "scale(-1 1)"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  id: "hero-image_svg__circle1004",
  opacity: 0.2,
  r: 53.399,
  cy: 534.76,
  cx: -612.041,
  transform: "scale(-1 1)"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  id: "hero-image_svg__circle1006",
  opacity: 0.2,
  r: 13.35,
  cy: 453.635,
  cx: -767.103,
  transform: "scale(-1 1)"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  id: "hero-image_svg__circle1008",
  opacity: 0.2,
  r: 7.097,
  cy: 141.346,
  cx: -240.394,
  transform: "scale(-1 1)"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  id: "hero-image_svg__circle1010",
  opacity: 0.2,
  r: 7.097,
  cy: 282.032,
  cx: -541.276,
  transform: "scale(-1 1)"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  id: "hero-image_svg__circle1012",
  opacity: 0.2,
  r: 9.242,
  cy: 422.828,
  cx: -621.283,
  transform: "scale(-1 1)"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  id: "hero-image_svg__circle1014",
  opacity: 0.2,
  r: 7.097,
  cy: 198.046,
  cx: -257.668,
  transform: "scale(-1 1)"
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  id: "hero-image_svg__circle1016",
  opacity: 0.2,
  r: 7.097,
  cy: 372.619,
  cx: -448.672,
  transform: "scale(-1 1)"
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  id: "hero-image_svg__circle1018",
  opacity: 0.2,
  r: 10.251,
  cy: 191.353,
  cx: -194.073,
  transform: "scale(-1 1)"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  id: "hero-image_svg__circle1020",
  opacity: 0.2,
  r: 10.251,
  cy: 444.998,
  cx: -507.279,
  transform: "scale(-1 1)"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  id: "hero-image_svg__circle1022",
  opacity: 0.2,
  r: 13.35,
  cy: 328.353,
  cx: -732.188,
  transform: "scale(-1 1)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  id: "hero-image_svg__path1024",
  fill: "#fff",
  d: "M557.41 534.338a-586.023 586.023 0 0065.93-3.81c65.83-7.476 126.545-25.142 170.959-49.743 44.957-24.902 67.962-54.06 64.777-82.104-2.206-19.429-20.985-36.819-57.41-53.162a-2.054 2.054 0 00-1.682 3.749c34.988 15.697 52.982 32.012 55.01 49.877 2.986 26.285-19.277 54.002-62.686 78.047-43.952 24.346-104.124 41.837-169.432 49.254-65.308 7.417-127.869 3.863-176.161-10.006-47.696-13.699-75.607-35.718-78.591-62.003-2.02-17.782 7.775-36.637 28.325-54.526a-2.054 2.054 0 00-2.698-3.099c-21.615 18.817-31.888 38.904-29.709 58.088 3.185 28.043 32.142 51.301 81.538 65.487 32.162 9.237 70.55 13.95 111.83 13.95z"
});

var _ref22 = /*#__PURE__*/React.createElement("g", {
  id: "hero-image_svg__g1015",
  transform: "translate(6 -6)"
}, /*#__PURE__*/React.createElement("circle", {
  transform: "scale(-1 1)",
  cx: -147.881,
  cy: 329.38,
  r: 6.161,
  fill: "#f2f2f2",
  id: "hero-image_svg__circle994"
}), /*#__PURE__*/React.createElement("circle", {
  transform: "scale(-1 1)",
  cx: -152.671,
  cy: 195.08,
  r: 34.141,
  fill: "#ffb8b8",
  id: "hero-image_svg__circle1036",
  strokeWidth: 1.144
}), /*#__PURE__*/React.createElement("path", {
  d: "M185.447 203.739s28.634-46.407-1.865-48.82a77.756 77.756 0 01-29.248-7.97c-10.11-5.144-22.835-9.054-29.607-1.135a50.32 50.32 0 01-10.237 9.483c-5.949 3.945-12.831 10.34-9.02 17.2l6.248 11.247 8.748 22.494c-2.037-9.702-2.089-17.848 3.124-21.869 0 0 29.081 12.376 43.737-9.997 16.406-12.31 21.626 26.436 18.12 29.367z",
  fill: "#2f2e41",
  id: "hero-image_svg__path1064",
  strokeWidth: 1.144
}), /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1.6351 0 0 1.6351 -852.054 -252.649)",
  fill: "#2f2e41",
  id: "hero-image_svg__polygon36",
  d: "M633.276 588.494l9.927-98.086-1.588-5.162-20.253-3.177-1.588 7.545-1.986 7.545-6.353 89.746z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.416 686.87l-14.934 22.725s-41.555 33.764-11.687 35.712c29.868 1.948 40.906-20.128 40.906-20.128s10.39-3.247 11.688-6.494c1.298-3.246-2.598-31.816-2.598-31.816z",
  fill: "#2f2e41",
  id: "hero-image_svg__path38",
  strokeWidth: 1.635
}), /*#__PURE__*/React.createElement("path", {
  d: "M150.298 704.4s-14.934 37.66-12.986 44.154c1.948 6.493 5.195 6.493 4.545 12.336-.649 5.844-2.597 19.48 22.077 20.129 24.673.65 12.986-32.465 12.986-32.465l-3.247-44.153z",
  fill: "#2f2e41",
  id: "hero-image_svg__path40",
  strokeWidth: 1.635
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.847 425.848s-9.09 15.583-7.792 25.323c1.299 9.74 20.129 114.278 20.129 114.278l14.934 127.264 33.114-2.597-12.986-117.525 3.247-93.5 5.844 68.827 38.309 1.298 22.726-98.045s-16.882-27.27-20.129-29.219c-3.247-1.948-97.396 3.896-97.396 3.896z",
  fill: "#2f2e41",
  id: "hero-image_svg__path42",
  strokeWidth: 1.635
}), /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1.6351 0 0 1.6351 -852.054 -252.649)",
  fill: "#ffb8b8",
  id: "hero-image_svg__polygon46",
  d: "M610.243 310.916l26.209-3.971-14.295-26.606-14.296 7.942z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M185.36 238.198s-22.076 16.233-43.503 7.143l-32.465 82.462v103.24s48.698 14.284 75.969-2.598c0 0 19.48-3.895 22.726-3.246 3.246.65-11.688-175.962-11.688-175.962z",
  fill: "#d0cde1",
  id: "hero-image_svg__path48",
  strokeWidth: 1.635
}), /*#__PURE__*/React.createElement("path", {
  d: "M165.232 242.094l14.934 21.427a25.846 25.846 0 012.598 17.532c-1.948 10.389-3.896 146.094 14.284 151.288 18.181 5.195 29.869 4.545 29.869 4.545s-16.233-77.916-10.39-91.552l18.181-81.813-48.048-27.27s-3.005-12.337-7.996-5.52a46.158 46.158 0 01-13.432 11.363z",
  fill: "#575a89",
  id: "hero-image_svg__path50",
  strokeWidth: 1.635
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.729 362.865l22.179-124.667-22.18 11.688s-25.322 10.389-30.517 22.726c-5.194 12.337-25.972 71.424-25.972 71.424s5.195 35.711 24.674 20.777c19.479-14.934 14.934-22.076 14.934-22.076s-16.882 68.826-14.285 70.774c2.597 1.948 3.896 20.129 3.896 20.129l20.128-3.896z",
  fill: "#575a89",
  id: "hero-image_svg__path52",
  strokeWidth: 1.635
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.406 293.39l8.44-12.337s19.092-38.31 32.921-25.323c13.83 12.986-25.778 42.854-25.778 42.854z",
  fill: "#ffb8b8",
  id: "hero-image_svg__path54",
  strokeWidth: 1.635
}), /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1.6351 0 0 1.6351 -852.054 -252.649)",
  fill: "#ffb8b8",
  id: "hero-image_svg__polygon56",
  d: "M646.777 420.226l7.942 10.219 3.574-7.148-8.339-7.147z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.003 286.247l15.583 9.74-15.583 64.93s-24.674 30.518-33.764 0C57.63 335.373 86.416 300.275 96 289.514c1.866-2.094 3.004-3.267 3.004-3.267z",
  fill: "#575a89",
  id: "hero-image_svg__path60",
  strokeWidth: 1.635
}), /*#__PURE__*/React.createElement("path", {
  d: "M219.774 262.223h14.934s12.986 25.323 14.285 38.958c1.299 13.636 1.299 67.528 1.299 67.528l-25.323 75.32-19.48-14.285 16.233-44.802s-1.948-9.74 0-14.285-5.844-27.92-7.142-29.219c-1.299-1.298 5.194-79.215 5.194-79.215z",
  fill: "#575a89",
  id: "hero-image_svg__path62",
  strokeWidth: 1.635
}));

function SvgHeroImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 887 793",
    height: 793,
    width: 887,
    "data-name": "Layer 1",
    id: "hero-image_svg__a0910be2-6cb3-414b-9b74-c9f97494131d"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
}

export default __webpack_public_path__ + "static/hero-image.5c33c60a.svg";
export { SvgHeroImage as ReactComponent };